<template>
<w-settings-summary ref="settingsSummary" :menu="menu" @change="onChangeMenu">
  <component slot="activeView" :is="activeView" :title="activeMenu.name"></component>
</w-settings-summary>
</template>

<script>
import findIndex from 'lodash/findIndex';
import { getValueAfterCheckEmpty } from '@/utils/string';
import isEmpty from 'lodash/isEmpty';
import summaryApi from '@/api/settings/settings-summary';
import WSettingsSummary from '@/components/template/SettingsSummary';
import WDeviceRegistration from './DeviceRegistration';
import WLogicalGroupSettings from './LogicalGroupSettings';
import WUserAndAuthManagement from './UserAndAuthManagement';

export default {
  name: 'WBasicSettings',
  components: {
    WSettingsSummary,
    WDeviceRegistration,
    WLogicalGroupSettings,
    WUserAndAuthManagement,
  },
  data() {
    return {
      activeMenu: {},
      activeView: null,
      menu: [
        {
          id: 'deviceRegistration',
          name: '장비 등록',
          desc: ['신규 장비 등록 및 관리 여부 설정이 가능합니다.'],
          data: null,
          orderbyIndex: 1,
        },
        {
          id: 'logicalGroupSettings',
          name: '논리 그룹 등록',
          desc: ['관리 대상에 대한 논리적인 그룹 설정 및', '개별 장비에 대한 설정 정보 수정이 가능합니다.'],
          data: null,
          orderbyIndex: 2,
        },
        {
          id: 'userAndAuthManagement',
          name: '사용자/권한 관리',
          desc: ['신규 장비 등록 및 관리 여부 설정이 가능합니다.'],
          data: null,
          orderbyIndex: 3,
        },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    onChangeMenu(activeView, activeMenu) {
      this.activeView = activeView;
      this.activeMenu = activeMenu;
    },
    clearActiveView() {
      this.$refs.settingsSummary.clearActiveView();
      this.loadData();
    },
    loadData() {
      summaryApi.getBasicSettingSummaryCount().then((response) => {
        const result = response.data;
        if (result.success === true && !isEmpty(result.data)) {
          const data = result.data;

          const deviceRegistrationData = [];
          const userAndAuthManagementData = [];

          deviceRegistrationData.push(`현재 관리 중인 장비 수는 <em>${getValueAfterCheckEmpty(data.deviceCount)}대</em> 입니다.`);
          userAndAuthManagementData.push(`현재 등록된 사용자는 총 <em>${getValueAfterCheckEmpty(data.userCount)}명</em> 입니다.`);

          const deviceRegistrationIndex = findIndex(this.menu, (item) => item.id === 'deviceRegistration');
          this.menu[deviceRegistrationIndex].data = deviceRegistrationData;

          const userAndAuthManagementIndex = findIndex(this.menu, (item) => item.id === 'userAndAuthManagement');
          this.menu[userAndAuthManagementIndex].data = userAndAuthManagementData;
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/index.vue